import * as yup from 'yup';

export const attachTransactionDrawerSchema = yup.object().shape({
  checkId: yup.string().max(40).required().default(''),
  locationId: yup.string().required().default(''),
});
